<template>
  <div>
    <TopbarOrganism title="Users" />
    <TableMolecule :dataType="dataType" :filterOptions="filterOptions" />
  </div>
</template>

<script setup lang="ts">
  import TopbarOrganism from '@/components/organisms/topbar-organism/TopbarOrganism.vue';
  import TableMolecule from '@/components/molecules/table-molecule/TableMolecule.vue';
  import { SearchbarModalOptions } from '@/shared/searchbarModalOptions';
  import { ref } from 'vue';

  const dataType = 'User';

  const getDateDaysAgo = (days: number): string => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date.toISOString();
  };

  const filterOptions = ref<SearchbarModalOptions[]>([
    new SearchbarModalOptions(
      `created_at:gte:${getDateDaysAgo(7)}`,
      'Last 7 days'
    ),
    new SearchbarModalOptions(
      `created_at:gte:${getDateDaysAgo(30)}`,
      'Last 30 days'
    ),
    new SearchbarModalOptions(
      `created_at:gte:${getDateDaysAgo(90)}`,
      'Last 90 days'
    ),
    new SearchbarModalOptions(
      `created_at:gte:${getDateDaysAgo(180)}`,
      'Last 6 months'
    ),
    new SearchbarModalOptions(
      `created_at:gte:${getDateDaysAgo(365)}`,
      'Last year'
    ),
  ]);
</script>

<style scoped>
  a {
    text-decoration: none;
  }
</style>
